import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import {
  Close as CloseIcon,
  ContentCopy,
  Email as EmailIcon,
} from "@mui/icons-material";
import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
} from "react-share";
import { toast } from "react-toastify";

const ShareModal = ({ open, onClose, content, url }) => {
  // Prepare sharing metadata
  const shareTitle = `Support ${content?.user?.name} on Swoodle`;
  const shareDescription = `Join us in supporting ${content?.user?.name}. Get amazing discounts while contributing to a great cause!`;
  const shareImage = process.env.REACT_APP_S3_URL + content?.banner;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    toast.success("Link copied to clipboard!", {
      style: {
        background: "#E6F7FB",
        color: "#007EA7",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
        padding: "12px 16px",
      },
      progressStyle: {
        background: "#007EA7",
      },
      icon: "✅",
    });
  };

  // Custom email share handler to prevent new window
  const handleEmailShare = (e) => {
    e.preventDefault(); // Prevent default action

    const subject = encodeURIComponent(shareTitle);
    const body = encodeURIComponent(`${shareDescription}\n\n${url}`);
    const mailtoLink = `mailto:?subject=${subject}&body=${body}`;

    try {
      // Use window.location instead of creating an anchor element
      window.location.href = mailtoLink;
      // toast.success('Opening email client...');
    } catch (err) {
      console.error("Failed to open email client:", err);
      toast.error("Could not open email client. Try copying the link instead.");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "10px",
          // padding: '16px'
        },
      }}
    >
      <DialogTitle
        sx={{
          borderBottom: "1px solid #DFE1E6",
          padding: "14px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: "#303030",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Share Fundraiser
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: "#8C8C8C",
            padding: 0,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "14px" }}>
        <Typography
          sx={{
            color: "#8C8C8C",
            fontSize: "14px",
            marginBottom: "24px",
            marginTop: "14px",
          }}
        >
          Share this fundraiser with your friends and family
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            gap: "16px",
            marginBottom: "32px",
          }}
        >
          <FacebookShareButton
            url={url}
            quote={shareDescription}
            hashtag="#Swoodle"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <FacebookIcon size={40} round />
              <Typography sx={{ fontSize: "12px", color: "#303030" }}>
                Facebook
              </Typography>
            </Box>
          </FacebookShareButton>

          <WhatsappShareButton url={url} title={shareTitle}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <WhatsappIcon size={40} round />
              <Typography sx={{ fontSize: "12px", color: "#303030" }}>
                WhatsApp
              </Typography>
            </Box>
          </WhatsappShareButton>

          <LinkedinShareButton
            url={url}
            title={shareTitle}
            summary={shareDescription}
            source="Swoodle"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <LinkedinIcon size={40} round />
              <Typography sx={{ fontSize: "12px", color: "#303030" }}>
                LinkedIn
              </Typography>
            </Box>
          </LinkedinShareButton>

          <Box
            onClick={handleEmailShare}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#8C8C8C",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <EmailIcon sx={{ color: "white" }} />
            </Box>
            <Typography sx={{ fontSize: "12px", color: "#303030" }}>
              Email
            </Typography>
          </Box>
        </Box>

        <Box
          onClick={handleCopyLink}
          sx={{
            display: "flex",
            alignItems: "start",
            gap: "12px",
            padding: "16px",
            border: "1px solid #DFE1E6",
            borderRadius: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#F4F4F4",
            },
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              noWrap
              sx={{
                color: "#303030",
                fontSize: "14px",
                whiteSpace: "pre-wrap",
              }}
            >
              {url}
            </Typography>
            <Typography
              sx={{
                color: "#00ADEF",
                fontSize: "12px",
                marginTop: "4px",
              }}
            >
              Click to copy link
            </Typography>
          </Box>
          <ContentCopy sx={{ color: "#8C8C8C" }} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ShareModal;
